import React from 'react';
import './about-us.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router-dom'
import { history } from '../../stores/index';
@(withRouter as any)
export default class AboutUs extends React.Component<any, any> {

    UNSAFE_componentWillMount() {
        setHeader({
            title: '关于我们',
            leftClick: this.leftClick,
        })
    }

    leftClick() {
        history.goBack()
    }

    render() {
        return (
            <div className="about-body">
                <p className="font1">三一重工在全国各地已有23个以上的园区及配套员工宿舍公寓，现构建集团社会化共享员工公寓服务平台，让员工体验互联智能的城市生活，致力于为企业园区提供酒店式、连锁化、一站式员工住宿服务。</p>
            </div>
        )
    }
}